import React,{useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize = 5;

const TcPrivacymain = () => {


  const[details, setDetails] =useState([])
  const[delDetail, setdelDetail] =useState([])
  const[content, setContent] =useState([])
  const[display, setDisplay] =useState(true)
  const[edit,setEdit]= useState(true)
const[del,setDel]= useState(true)

const[btn,setBtn]= useState(true)

const [allusers,setAllusers]= useState([])
    const [paginatedPosts, setpaginatedPosts] = useState();
    //const [currentPage, setcurrentPage] = useState(1);

  const[pop,setpop] = useState(false);
  useEffect(()=>{
    setpop(true);
    Getprivacypolicy();
   // GetTcUserAllRole()
    document.getElementById('Tc-sectionMain').style.display ="none";
     document.getElementById('TCprivacytable').style.display ="none";
     document.getElementById('pagination').style.display ="none";
    setTimeout(()=>{
      setpop(false);
      document.getElementById('Tc-sectionMain').style.display ="flex";
     document.getElementById('TCprivacytable').style.display ="flex";
     document.getElementById('pagination').style.display ="block";
      getRoleData()
      getUserRole();
    },1000)
  },[1])
     
  function Getprivacypolicy(){
     
      fetch('https://localhost:44312/Api/Tc/GetTcPrivacypolicy', {
       
      method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          //"Authorization": bearer,
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
    
   //body:JSON.stringify(data)
  
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
    setDetails(data)
     setAllusers(data)
        setpaginatedPosts(data);
        localStorage.setItem("PrivacyPolicyData", JSON.stringify(data));

  });
  
  }
  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
  //   // if (pageCount === 1)
  //   // return null;
    
  //   const pages = _.range(1, pageCount+1)
    
  //   const pagination =(pageNo)=>{
  //   setcurrentPage(pageNo);
  //   const startIndex = (pageNo - 1) * pageSize;
  //   const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  //   setpaginatedPosts(paginatedPost)
  //   }

    function handlechange(){
      var HeadingInput = document.getElementById("headinput").value
      var ContentInput =  document.getElementById("contentinput").value
  
      if(!HeadingInput){
        document.getElementById('headinputError').innerHTML="Heading Required"
      }
      else{
        document.getElementById('headinputError').innerHTML=""
      }
      if(!ContentInput){
        document.getElementById('contentinputError').innerHTML="Content Required"
      }
      else{
        document.getElementById('contentinputError').innerHTML=""
      
    }}
  function AddTcprivacypolicy(){

    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
    var HeadingInput = document.getElementById("headinput").value
    var ContentInput =  document.getElementById("contentinput").value

    if(!HeadingInput){
      document.getElementById('headinputError').innerHTML="Heading Required"
    }
    else{
      document.getElementById('headinputError').innerHTML=""
    }
    if(!ContentInput){
      document.getElementById('contentinputError').innerHTML="Content Required"
    }
    else{
      document.getElementById('contentinputError').innerHTML=""
    
            const body ={

              heading: HeadingInput,
             content: ContentInput,
          createdBy: "123"

            }
  //           var table = document.getElementById("TcTable");
  //           var row = table.insertRow(1);
  // var cell1 = row.insertCell(0);
  // var cell2 = row.insertCell(1);
  // cell1.innerHTML =HeadingInput ;
  // cell2.innerHTML = ContentInput;
             console.log(body)
              axios({
             
              method:"POST",
               //url: `${BASE_URL}/Tc/TcUserAddress`,
             url:"https://localhost:44312/Api/Tc/AddTcprivacypolicy",
             data:body,
             headers: {
             "Content-Type" : "application/json",
             'Authorization':bearer
             }
      
              })
              .then((response) =>{
              console.log(response.data);

              Getprivacypolicy()
              //window.location.reload(); 
              if(response.data.status=='Success'){
                document.getElementById('success-notify').style.display = "block"
                 setTimeout(()=>{
                   document.getElementById('success-notify').style.display = "none"
                 },1000)
              }
             //alert(" Privacy Policy Added Sucessfully");
               document.getElementById("headinput").value = ""
      document.getElementById("contentinput").value = ""
             
              })
              .catch(error => {
                console.log(error);
              // alert(" Privacy Policy Added Failed !")
              document.getElementById('error-notify').style.display = "block"
              setTimeout(()=>{
                document.getElementById('error-notify').style.display = "none"
              },1000)
              })
            } 
          }
            function getEditContent(Id){

              let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
              
              document.getElementById("tcContenteditForm").style.display = "block";
            
             const body ={
              
              id:Id
            
             }
             console.log(body);
            
            
              axios({          
                 method: "POST", 
                 //url: `${BASE_URL}/Tc/EditSection`,      
                 url: "https://localhost:44312/Api/Tc/EditTcPrivacypolicy",
                 data:body,
                 headers: {             
                   'Content-Type': 'application/json' , 
                   'Authorization':bearer     
                 }
               
               })
               .then((response) =>{
                console.log(response.data);
                setContent(response.data)
            
                 }) 
               
             
            } 

            function closeContentEditForm()
{

document.getElementById("tcContenteditForm").style.display = "none";
document.getElementById("contentreset").reset();
document.getElementById('UpdateSecErrA').innerHTML = ""
document.getElementById('UpdateSecErrB').innerHTML = ""

}
function edithandlechange(){

  var HeadingInput = document.getElementById("headingInputA").value
  var ContentInput =  document.getElementById("contentInputA").value

  if(!HeadingInput){
    document.getElementById('UpdateSecErrA').innerHTML = "Heading Required"
  }
  else{
    document.getElementById('UpdateSecErrA').innerHTML = ""
  }
   if (!ContentInput){
   
    document.getElementById('UpdateSecErrB').innerHTML = "Content Required"

  }
  else{
    document.getElementById('UpdateSecErrB').innerHTML = ""
  }
}

function updateContent(Id){

  var HeadingInput = document.getElementById("headingInputA").value
    var ContentInput =  document.getElementById("contentInputA").value

    if(!HeadingInput){
      document.getElementById('UpdateSecErrA').innerHTML = "Heading Required"
    }
    else if (!ContentInput){
      document.getElementById('UpdateSecErrA').innerHTML = ""
      document.getElementById('UpdateSecErrB').innerHTML = "Content Required"

    }
    else{
      document.getElementById('UpdateSecErrB').innerHTML = ""
    
            const body ={

              heading: HeadingInput,
             content: ContentInput,
                 id:Id,
               editedBy:"1234" 
  
   }
   console.log(body);
  
   let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/UpdateTcprivacypolicy",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      closeContentEditForm()
      if(response.data.status=='Success'){
        document.getElementById('edit-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('edit-notify').style.display = "none"
         },1000)
      }
   //alert (" Privacy Policy Updated Sucessfully ");

           Getprivacypolicy()
          
       }) 
      }
}

function delContent(Id){
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
 
  const body ={
    id:Id
  }
   console.log(body)
    axios({
   
    method:"POST",
     //url: `${BASE_URL}/Tc/Sectiondelete`,
   url:"https://localhost:44312/Api/Tc/DeleteTcprivacypolicy",
   data:body,
   headers: {
   "Content-Type" : "application/json",
   'Authorization':bearer
   }
    })
    .then((response) =>{
    console.log(response.data);
 
    Getprivacypolicy() 
    document.getElementById("modalDeleteForm").style.display = "none";
    if(response.data.status=='Success'){
      document.getElementById('del-notify').style.display = "block"
       setTimeout(()=>{
         document.getElementById('del-notify').style.display = "none"
       },1000)
    }
 //alert (" Privacy Policy Deleted Sucessfully");
  
    })
}         
  
function ConfirmDelete(Id){

  document.getElementById("modalDeleteForm").style.display = "block";
  getDetails(Id)

}
 

function getDetails(Id){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
 

 const body ={
  
  id:Id

 }
 console.log(body);


  axios({          
     method: "POST", 
     //url: `${BASE_URL}/Tc/EditSection`,      
     url: "https://localhost:44312/Api/Tc/GetTcPolicy",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    setdelDetail(response.data)

     }) 

} 
function closedelForm()
{
   document.getElementById("modalDeleteForm").style.display = "none";
 
 }


function Cancel() {
document.getElementById("modalDeleteForm").style.display = "none";      

   }


   function getRoleData(){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   let UserRole =  localStorage.getItem("Role");
  
   const body ={
    
    role:UserRole
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
      
       }) 
     
      }

      // function GetTcUserRole(){
      //   fetch('https://localhost:44312/Api/Tc/GetTcUserAllRole', {
      //     method:'GET',
      //     headers : {
    
      //       "Content-type": "application/json",
    
      //       "Accept": "application/json",
      
      //      // "Authorization": "Bearer " + `${token}`,
      
      //       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      //     },
    
      //     //body:JSON.stringify(data)
    
      //   })
      //    .then(response => response.json())
      //   .then(data => {
      //     console.log(data)   
         
      //     localStorage.setItem("RoleData", JSON.stringify(data));
        
      //   });
      // }
      // function GetTcUserAllRole(){
      //   fetch('https://localhost:44312/Api/Tc/GetTcUserAllRole', {
      //     method:'GET',
      //     headers : {
    
      //       "Content-type": "application/json",
    
      //       "Accept": "application/json",
      
      //      // "Authorization": "Bearer " + `${token}`,
      
      //       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      //     },
    
      //     //body:JSON.stringify(data)
    
      //   })
      //    .then(response => response.json())
      //   .then(data => {
      //     console.log(data)         
      //     localStorage.setItem("RoleData", JSON.stringify(data));
        
      //   });
      // }

   function getUserRole(){

    /**----getroleAction---- */
let Tcrole =  localStorage.getItem("loginUserRoleaction");
let roledata =  JSON.parse(Tcrole);
let role = roledata.map((e)=>e.roleAction);
console.log(role);

let roles = role.toString();
let Add = roles.includes('Add')
console.log(Add)

let View = roles.includes('View')
console.log(View)

let Edit = roles.includes('Edit')
console.log(Edit)

let Delete = roles.includes('Delete')
console.log(Delete)
let empty = roles.includes('')
console.log(empty)


let roleid = localStorage.getItem('RoleId')
let id = roleid.includes('01')
console.log(id)
 /**----- Conditions--- **/

 if(id==true&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
 {
 setEdit(true);
 setDel(true);
 setDisplay(true); 
 document.getElementById('ActionData').style.display ="block";
 document.getElementById('TCprivacybtn').style.display ="block";
 document.getElementById('action-err').innerHTML = ''
 }
 if(id==false&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
 {
  setEdit(false);
  setDel(false);
  document.getElementById('TCprivacybtn').style.display ="none";
  document.getElementById('TCprivacytable').style.display ="none";
  document.getElementById('inputs').style.display ="none";
  document.getElementById('pagination').style.display ="none";
  document.getElementById('action-err').innerHTML = 'No Task Assign'
 }

if(Add==true&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true);   
  document.getElementById('TCprivacybtn').style.display ="block";  
  document.getElementById('ActionData').style.display ="block";
}
if(Add==false&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCprivacybtn').style.display ="none"; 
  document.getElementById('inputs').style.display ="none";  
  document.getElementById('ActionData').style.display ="block";
}

if( Add==true&&View==false&&Edit==false&&Delete==false){
 
  document.getElementById('TCprivacybtn').style.display ="block";
  setDisplay(false);

  document.getElementById('TCprivacytable').style.display ="none";
  document.getElementById('pagination').style.display ="none";
}


if( Add==false&&View==true&&Edit==false&&Delete==false){
  setDisplay(false);
  document.getElementById('TCprivacybtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
  document.getElementById('ActionData').style.display ="none";


}


if( Add==false&&View==false&&Edit==true&&Delete==false){
  setDel(false); 
  document.getElementById('TCprivacybtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
   }

   if( Add==false&&View==false&&Edit==false&&Delete==true){
    setEdit(false); 
    document.getElementById('TCprivacybtn').style.display ="none";
    document.getElementById('inputs').style.display ="none";
     }
     if(Add==false&&View==false&&Edit==true&&Delete==true){
      setEdit(true);
      setDel(true);
      setDisplay(true); 
      document.getElementById('TCprivacybtn').style.display ="none";
      document.getElementById('inputs').style.display ="none";
      document.getElementById('ActionData').style.display ="block";
   }
   if(Add==true&&View==true&&Edit==false&&Delete==false){
    setEdit(false);
    setDel(false);
    setDisplay(false); 
    document.getElementById('TCprivacybtn').style.display ="block";  
    
 }
 

if(Add==true&&View==false&&Edit==true&&Delete==false){
  setDel(false);
  setEdit(true);
 
  setDisplay(true);  

  document.getElementById('TCprivacybtn').style.display ="block";  
  document.getElementById('ActionData').style.display ="block";
}

if(Add==true&&View==false&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCprivacybtn').style.display ="block";  
  document.getElementById('ActionData').style.display ="block";
}   
if(Add==true&&View==false&&Edit==false&&Delete==true){
  setEdit(false);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCprivacybtn').style.display ="block";  
  document.getElementById('ActionData').style.display ="block";
}   

if( Add==false&&View==true&&Edit==false&&Delete==true){
  setEdit(false); 
  setDel(true); 
  document.getElementById('TCprivacybtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
   }
   if( Add==false&&View==true&&Edit==true&&Delete==false){
    setEdit(true); 
    setDel(false); 
    document.getElementById('TCprivacybtn').style.display ="none";
    document.getElementById('inputs').style.display ="none";
     }
     if( Add==true&&View==true&&Edit==true&&Delete==false){
      setEdit(true); 
      setDel(false); 
      document.getElementById('TCprivacybtn').style.display ="block";
       }
       if( Add==true&&View==true&&Edit==false&&Delete==true){
        setEdit(false); 
        setDel(true); 
        document.getElementById('TCprivacybtn').style.display ="block";
         }
   }

   const LEFT_PAGE = "LEFT";
   const RIGHT_PAGE = "RIGHT";
   const range = (from, to, step = 1) => {
     let i = from;
     const range = [];
   
     while (i <= to) {
       range.push(i);
       i += step;
     }
   
     return range;
   };
   
   const [currentPage, setCurrentPage] = useState(1);
   
   let data =  localStorage.getItem("PrivacyPolicyData")
  
   let transdata =  JSON.parse(data);
   let NUM_OF_RECORDS = transdata.length;
   let LIMIT = 5;
   
   const onPageChanged = useCallback(
   
     (event, page) => {
       event.preventDefault();
       setCurrentPage(page);
     },
     [setCurrentPage]
     
   );
   
   
   const currentData = transdata.slice(
     (currentPage - 1) * LIMIT,
     (currentPage - 1) * LIMIT + LIMIT
   );
   
   const Paginations = (props) => {
     const {
       totalRecords,
       pageLimit,
       pageNeighbours,
       onPageChanged,
       currentPage
     } = props;
     const [totalPages, setTotalPages] = useState(0);
     useEffect(() => {
       setTotalPages(Math.ceil(totalRecords / pageLimit));
     }, [setTotalPages]);
   
     const fetchPageNumbers = () => {
       const totalNumbers = pageNeighbours * 2 + 3;
       
       const totalBlocks = totalNumbers + 2;
      
   
       if (totalPages > totalBlocks) {
         const startPage = Math.max(2, currentPage - pageNeighbours);
         const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
   
         let pages = range(startPage, endPage);
   
         const hasLeftSpill = startPage > 2;
         const hasRightSpill = totalPages - endPage > 1;
         const spillOffset = totalNumbers - (pages.length + 1);
   
         switch (true) {
           case hasLeftSpill && !hasRightSpill: {
             const extraPages = range(startPage - spillOffset, startPage - 1);
             pages = [LEFT_PAGE, ...extraPages, ...pages];
             break;
           }
           case hasLeftSpill && hasRightSpill:
           default: {
             pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
             break;
           }
         }
         return [1, ...pages, totalPages];
       }
       return range(1, totalPages);
     };
   
   
     const pages = fetchPageNumbers() || [];
     return (
       <nav aria-label="Countries Pagination">
         <ul className="pagination">
           {pages.map((page, index) => {
             if (page === LEFT_PAGE)
               return (
                 <li key={index} className="page-item">
                   <a
                     href="/"
                     className="page-link"
                     aria-label="Previous"
                     onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                   >
                     <span aria-hidden="true">&laquo;</span>
                   </a>
                 </li>
               );
   
             if (page === RIGHT_PAGE)
               return (
                 <li key={index} className="page-item">
                   <a
                     className="page-link"
                     href="/"
                     aria-label="Next"
                     onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                   >
                     <span aria-hidden="true">&raquo;</span>
                   </a>
                 </li>
               );
   
             return (
               <li
                 key={index}
                 className={`Tc-page-item${currentPage === page ? " active" : ""}`}
               >
                 <a
                   className="page-link"
                   href="/"
                   onClick={(e) => onPageChanged(e, page)}
                 >
                   {page}
                 </a>
               </li>
             );
           })}
         </ul>
       </nav>
     );
   }; 
return(
    <>
 
        <div className='TC-addmain'> 
          
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Privacy Policy </span>
    </div>
    </div>
   
    <div className='Tc-privacyMain' id='Tc-sectionMain'>
    <span id='action-err'></span> 
{/* <div> */}

  
    <div id='inputs'>
     
    <input  placeholder="Heading" id='headinput' className='privacyInput' onKeyUp={handlechange}></input><br></br>
    <span className="Tcadduser-error" id='headinputError'></span><br></br>    
    <textarea placeholder="Content" id='contentinput' className='privacyInput'onKeyUp={handlechange}></textarea><br></br>
    <span id='contentinputError' className="Tcadduser-error"></span> <br></br>
    <button class=" AddBtn" id='TCprivacybtn'><span onClick={AddTcprivacypolicy}><i className="fa-regular fa-square-plus"></i></span><span onClick={AddTcprivacypolicy}>ADD </span></button> 
    </div> 
    
     
    
   {/* <button id='TCprivacybtn' onClick={AddTcprivacypolicy}>ADD</button> */}

</div>

 {/* --- Privacy table--- */}

<div className='TCprivacytable' id='TCprivacytable'>
     <div class="TC-table_responsive">
     {
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
       <table  className='TC-tblhead' id='TcTable'> 
    <thead>
   <tr>
<th>Heading</th>
<th>Content</th>
{display?<th id='ActionData'>Action</th>:null}

</tr>
</thead>
<tbody>

{currentData.map((e)=>
{
 
return<tr id='row'>

<td style={{inlineSize:"450px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.heading}</td>

<td style={{inlineSize:"950px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.content}</td>


{display?<td id='ActionData' style={{whiteSpace:"nowrap"}}>{edit?<i id='Tcediticon' onClick={()=>getEditContent(e.id)} className="fa-regular fa-pen-to-square"></i>:null}&nbsp;&nbsp;&nbsp;

{del?<i className="fa-solid fa-trash" id='Tcdelicon' onClick={()=>ConfirmDelete(e.id)} ></i>:null}<span id='action-err'></span></td>:null}

</tr>

}
)}
</tbody>

</table>
)}

     </div>
  </div>

  <br></br> <br></br>
  <div id='pagination'>
    <form id='padination-form'>
    {
  !paginatedPosts ? (""):(
  <nav id='Tc-Pag'>
    {transdata.length<=5 ? null: <ul className='Tc-pagination'>
    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
     
    </ul>}
  </nav>
  )}
  </form>
  </div>
  <br></br> <br></br>
    {/* </div>  */}

    <div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Privacy Policy&nbsp; <span style={{color:"blue"}}>Added</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
         
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Privacy Policy&nbsp; Added </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down" style={{fontSize:'25px'}}></i></h6>
     
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Privacy Policy&nbsp; <span style={{color:"blue"}}>Updated</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
    
          </section> 
            
          
    </div>
  </div>
</div>
<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Privacy Policy&nbsp; <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
         
          </section> 
            
          
    </div>
  </div>
</div>
   
  {/* --- Edit form--- */}

    <form id="contentreset" >
<div className='TCpopfade' id="tcContenteditForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup-privacy">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold" >Edit Content</h4>
        <button type="button" className="close"onClick={closeContentEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      
      {content.map((e)=>
{
return<div>
   <div className="modal-body mx-3">
   <div className="md-form mb-3">
   <label>Heading</label>
                  <input id='headingInputA'  defaultValue={e.heading} onKeyUp={edithandlechange} />
                  <span id='UpdateSecErrA' className='TcProfile-error'></span>
                  </div>
                  <div className="md-form mb-3">
                  <label>Content</label>
                  <textarea id='contentInputA'  defaultValue={e.content} onKeyUp={edithandlechange}/>
                  <span id='UpdateSecErrB' className='TcProfile-error'></span>
                  </div>
    
                </div>
                  <div className="modal-footer d-flex justify-content-center">
                  <button className='TC-adduser-button' onClick={()=>updateContent(e.id)}>Update</button>
      
                  </div>
 </div>
 }
 )}
           

    </div>
  </div>
</div>
</form>
 
  {/* --- Delete Form --- */}

<div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{delDetail.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
          </div>
        </div>
   </div>
      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>delContent(e.id)}  type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>
 
     {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    
    </div>
   
   

    </>
)
}

export default TcPrivacymain;